import script from "./HistoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryModal.vue?vue&type=script&setup=true&lang=js"

import "./HistoryModal.vue?vue&type=style&index=0&id=d4e33016&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4e33016"]])

export default __exports__